import { PvhSizeWiseModel } from "./pvh-size-wise-data";


export class PvhOrderDataModel {

    id: number;
    poNumber: string;
    deliveryAddress: string;
    transMode: string;
    currency: string;
    poLine: string;
    material: string;
    totalUnitPrice: string;
    originalDate: string;
    status:string;
    deliveryDate:string;
    buyerName:string;
    sizeWiseData: PvhSizeWiseModel[];
    plmStyle:string
    totalQuantity?:string;
    color:string;
    division?:string;
    gender?:string;
    shortDescription?:string;
    portOfLoading?:string;
    orderValue?:string;
    unitPrice?:string;
    buyerSaveName?:string
    uniqueIdentifier?:string


    constructor(
        id: number,
        poNumber: string,
        deliveryAddress: string,
        transMode: string,
        currency: string,
        poLine: string,
        material: string,
        totalUnitPrice: string,
        originalDate: string,
        status:string,
        deliveryDate:string,
        buyerName:string,
        sizeWiseData: PvhSizeWiseModel[],
        plmStyle:string,
        totalQuantity?:string,
        color?:string,
        division?:string,
        gender?:string,
        shortDescription?:string,
        portOfLoading?:string,
        orderValue?:string,
        unitPrice?:string,
        buyerSaveName?:string,
        uniqueIdentifier?:string

       



    ) {
        this.id = id
        this.poNumber = poNumber
        this.deliveryAddress = deliveryAddress
        this.transMode = transMode
        this .currency=currency
        this.poLine = poLine
        this.material = material
        this.totalUnitPrice = totalUnitPrice
        this.originalDate = originalDate
        this.status=status
        this.deliveryDate=deliveryDate
        this.buyerName=buyerName
        this.sizeWiseData = sizeWiseData
        this.plmStyle=plmStyle
        this.totalQuantity=totalQuantity
        this.color= color
        this.division=division
        this.gender=gender
        this.shortDescription=shortDescription
        this.portOfLoading=portOfLoading
        this.orderValue=orderValue
        this.unitPrice=unitPrice
        this.buyerSaveName = buyerSaveName
        this.uniqueIdentifier = uniqueIdentifier
       



    }
}


